import { READ_ONLY, SELF_EMPLOYED_COACH, SUPERUSER } from '../../utils/userRoles';

export const NO_USER_TYPE_IDS = 'Please select at least one user type';
export const SUPERUSER_TYPE_ERROR = 'SuperUser cannot be mixed with other types';
export const READ_ONLY_TYPE_ERROR = 'Read Only user cannot be mixed with other types';
export const SELF_EMPLOYED_COACH_TYPE_ERROR =
    'Self Employed Coach cannot be mixed with other types';

export const validateUserTypes = (userTypeIds, errors, userTypes) => {
    if (userTypeIds?.length < 1) {
        return {
            ...errors,
            userTypeIds: { error: true, message: NO_USER_TYPE_IDS }
        };
    } else if (userTypeIds?.length > 1) {
        const superUserId = userTypes.find((entry) => entry.role === SUPERUSER)?.id;
        const readOnlyId = userTypes.find((entry) => entry.role === READ_ONLY)?.id;
        const selfEmployedCoachId = userTypes.find(
            (entry) => entry.role === SELF_EMPLOYED_COACH
        )?.id;

        if (userTypeIds.includes(superUserId)) {
            return {
                ...errors,
                userTypeIds: {
                    error: true,
                    message: SUPERUSER_TYPE_ERROR
                }
            };
        } else if (userTypeIds.includes(readOnlyId)) {
            return {
                ...errors,
                userTypeIds: {
                    error: true,
                    message: READ_ONLY_TYPE_ERROR
                }
            };
        } else if (userTypeIds.includes(selfEmployedCoachId)) {
            return {
                ...errors,
                userTypeIds: {
                    error: true,
                    message: SELF_EMPLOYED_COACH_TYPE_ERROR
                }
            };
        }
    }
    return errors;
};
